import { render, staticRenderFns } from "./ProfilesExpensesTable.vue?vue&type=template&id=1ee39f8a&scoped=true"
import script from "./ProfilesExpensesTable.vue?vue&type=script&lang=js"
export * from "./ProfilesExpensesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee39f8a",
  null
  
)

export default component.exports